<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <p class="h4" v-if="$localStorageService.can('DX_14_ver_clasificacion') || $localStorageService.can('DX_13_ver_clasificacion')">
    {{ data.item.clasificacion }}
    <i class="fa fa-circle " font-scale="3" :style=" { color: data.item.color }" aria-hidden="true">
    </i>
  </p>
</div>

</template>

<script>
export default {
    name: "BandejaClasificacionComponente",
    props: {
        data: Object,
    },
    methods: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },

}
</script>
